module.exports = require('./helpers/bundle-url').getBundleURL('lbB2N') + "linkedin_small.0fd34a59.svg";